module.exports = "/lucky-balls/img/infobox/info_Box_029.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_029.png
// module id = 1094
// module chunks = 0